import { mergeDeepRight } from 'ramda'
import { Embed } from 'types/embed'
import { createReducer } from 'utils/redux'

const defaultState: Embed = {
  id: undefined,
  configuration: {
    gates: [],
    dataProtection: undefined,
    showBranding: false,
    theme: {
      awayMessage: null,
      userList: [],
      userListMode: undefined,
      welcomeMessage: null,
    },
    team: [],
  },
  overrides: {}
}

const receiveEmbedWelcomeMessageHandler = ({ action, draft }) => {
  const { message, authorId } = action.payload

  draft.configuration.theme.welcomeMessage = message

  if (!!authorId) {
    draft.configuration.autoAssigneeId = authorId
  }
}

const receiveEmbedAwayMessageHandler = ({ action, draft }) => {
  const { message = null } = action.payload

  if (message) {
    draft.configuration.theme.awayMessage = action.payload.message
  }
}

const receiveEmbedConfigurationHandler = ({ action, draft }) => {
  const embedConfiguration = {
    ...draft.configuration,
    ...action.payload.configuration
  }

  return {
    ...action.payload,
    configuration: mergeDeepRight(embedConfiguration, draft.overrides),
    overrides: draft.overrides
  }
}

const receiveEmbedConfigurationOverrideHandler = ({ action, draft }) => {
  draft.overrides = action.payload
  draft.configuration = mergeDeepRight(draft.configuration, action.payload)
}

const actions = {
  RECEIVE_EMBED_CONFIGURATION: receiveEmbedConfigurationHandler,
  RECIEVE_EMBED_AWAY_MESSAGE: receiveEmbedAwayMessageHandler,
  RECEIVE_EMBED_WELCOME_MESSAGE: receiveEmbedWelcomeMessageHandler,
  RECEIVE_EMBED_CONFIGURATION_OVERRIDE: receiveEmbedConfigurationOverrideHandler
}

const embedReducer = createReducer(
  defaultState,
  actions
)

export default embedReducer
